{
  "title": "Tether Essence",
  "source": "Explorer's Guide to Wildemount",
  "levelAndSchool": "7th-level necromancy (dunamancy)",
  "level": 7,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (a spool of platinum cord worth at least 250 gp, which the spell consumes)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "Two creatures you can see within range must make a Constitution saving throw, with disadvantage if they are within 30 feet of each other. Either creature can willingly fail the save. If either save succeeds, the spell has no effect. If both saves fail, the creatures are magically linked for the duration, regardless of the distance between them. When damage is dealt to one of them, the same damage is dealt to the other one. If hit points are restored to one of them, the same number of hit points are restored to the other one. If either of the tethered creatures is reduced to 0 hit points, the spell ends on both. If the spell ends on one creature, it ends on both."
  ],
  "spellLists": ["wizard"]
}
